import React from "react";
import { ArrowRight, Info } from "lucide-react";
import { Button } from "./ui/button";
import { SERVICES } from "../mock";

export default function Services({ onBookService, onViewDetails }) {
  return (
    <section id="services" className="py-20 subtle-gradient">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-sky-700 text-xs font-bold uppercase tracking-wider mb-3">
            Our Services
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a4f8a] mb-3">
            Trusted Plumbing Services for Every Sydney Property
          </h2>
          <p className="text-slate-600">
            Residential and commercial. From a leaky tap to a full hot water replacement —
            click any service below to see details or book it instantly.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s) => (
            <div
              key={s.id}
              className="card-lift bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm flex flex-col"
            >
              <div
                className="relative h-48 overflow-hidden cursor-pointer bg-slate-100"
                onClick={() => onViewDetails(s)}
              >
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover img-zoom"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#07304f]/60 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-lg drop-shadow">{s.title}</h3>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <p className="text-sm text-slate-600 mb-4 flex-1">{s.short}</p>
                <div className="flex flex-col gap-2">
                  <Button
                    onClick={() => onBookService(s)}
                    className="w-full bg-[#0a4f8a] hover:bg-[#083d6e] text-white font-semibold group"
                  >
                    Book this service
                    <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
                  </Button>
                  <button
                    onClick={() => onViewDetails(s)}
                    className="text-xs font-semibold text-[#0a4f8a] hover:text-sky-600 flex items-center justify-center gap-1 py-1 transition-colors"
                  >
                    <Info size={12} /> View service details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
